export function loginRedirectCall() {
  const role = localStorage.getItem("user_login_type_role");
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  let path = null;

  switch (role) {
    case "1":
      path = `${baseUrl}/patient/splash-screen`;
      break;
    case "2":
      path = `${baseUrl}/doctor/splash-screen`;
      break;
    case "4":
      path = `${baseUrl}/priest/splash-screen`;
      break;
    default:
      console.warn("Unknown role:", role);
      path = `${baseUrl}/login`; // fallback page
  }

  window.location.href = path;
}

export function logOutRedirect() {
  let path = window.location.protocol + "//" + window.location.host + "/";
  window.location.href = path;
}
export function logOutRedirectCall() {
  localStorage.removeItem("user_login");
  localStorage.removeItem("user_token");
  localStorage.removeItem("user_name");
  localStorage.removeItem("user_id");
  localStorage.removeItem("user_email");
  localStorage.removeItem("user_country_code");
  localStorage.removeItem("user_phone");
  localStorage.removeItem("user_role");
  localStorage.removeItem("user_login_type_role");
  localStorage.removeItem("profile_image");
  localStorage.removeItem("monteChatId");
  localStorage.removeItem("onlineStatus");
  localStorage.removeItem("messageShown");
  localStorage.removeItem("availableStatus");
  logOutRedirect();
}

export function loginStoreData(data) {
  localStorage.setItem("user_login", true);
  localStorage.setItem("user_token", data.token);
  localStorage.setItem("user_name", data.first_name);
  localStorage.setItem("user_id", data.id);
  localStorage.setItem("user_email", data.email);
  localStorage.setItem("user_country_code", data.country_code);
  localStorage.setItem("user_phone", data.mobile_number);
  localStorage.setItem("user_role", data.role);
  localStorage.setItem("user_login_type_role", data.login_type_role);
  localStorage.setItem("profile_image", data.profile_image);
  localStorage.setItem("onlineStatus", data.onlineStatus);
  localStorage.setItem("availableStatus", data.availableStatus);
  loginRedirectCall();
}
